<template>
  <v-form ref="form1">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Intake</span>

      <v-card class="card w-100 d-flex flex-column ga-4" flat>
        <span class="text-normal text-primary"
          >Selecteer hoe je de intake bij ons wilt doen.</span
        >

        <v-radio-group
          :rules="[rules.select_rules.required]"
          v-model="localQuestions['Intake']"
          class="mt-4"
        >
          <v-radio
            class="radio-btn-rounded"
            color="secondary"
            label="Telefonisch"
            value="Telefonisch"
          >
            <template v-slot:label>
              <div class="">
                <strong>Telefonisch</strong>
                <p class="text-small">
                  15 minuten om samen je persoonlijke plan door te spreken.
                </p>
              </div>
            </template>
          </v-radio>
          <v-radio
            class="radio-btn-rounded"
            color="secondary"
            label="Mail"
            value="Mail"
          >
            <template v-slot:label>
              <div class="">
                <strong>Mail</strong>
                <p class="text-small">
                  Ontvang een duidelijke uitleg over je persoonlijke plan in je
                  inbox.
                </p>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.localQuestions["Intake"] = "Telefonisch";
  },
  data() {
    return {
      rules: FormRules.rules,
      localQuestions: { ...this.questions },
    };
  },
  methods: {
    nextStep() {
      this.$emit("nextStep", this.intake);
    },
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
